import { useCallback, useEffect, useState } from "react";
import { axios, errorResponse } from "../../helpers";

const useCanceledTransactions = (token) => {
    const [transactions, setTransactions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState("");

    const formatTransactions = useCallback((items) => {
        return items.map((transaction) => {
            // Get image from povStyles (first product's povStyles)
            let image = 'https://placehold.co/60x60/png';
            if (transaction.products && transaction.products.length > 0) {
                const firstProduct = transaction.products[0];
                if (firstProduct.povStyles && firstProduct.povStyles.length > 0) {
                    image = firstProduct.povStyles[0].image || image;
                }
            }

            // Get product names
            const productNames = transaction.products?.map(p => p.name) || [];
            const categoryNames = transaction.products?.map(p => p.category) || [];

            return {
                id: transaction.order_id_midtrans || "N/A",
                product:
                    productNames.length > 0
                        ? productNames.join(", ")
                        : "N/A",
                date: new Date(transaction.createdAt).toLocaleDateString("id-ID"),
                orderStatus: transaction.statusOrder || "N/A",
                paymentStatus: transaction.statusPayment || "N/A",
                category:
                    categoryNames.length > 0
                        ? categoryNames.join(", ")
                        : "Custom",
                orderType: transaction.order_details?.length > 0 ? "custom" : "regular",
                total: new Intl.NumberFormat("id-ID", {
                    style: "currency",
                    currency: "IDR",
                }).format(transaction.total_amount || 0),
                shipping:
                    transaction.jasaPengiriman || transaction.address?.city?.name || "N/A",
                image: image,
                rawTotal: transaction.total_amount || 0,
            };
        });
    }, []);

    const fetchCanceledTransactions = useCallback(async () => {
        if (!token) {
            setIsLoading(false);
            return;
        }
        try {
            setIsLoading(true);
            const response = await axios.get("/v1/transactions/canceled", {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response.data.success) {
                setTransactions(formatTransactions(response.data.data));
                setError("");
            } else {
                setError(response.data.message || "Failed to fetch transactions");
            }
        } catch (err) {
            const msg = errorResponse(err) || "Error fetching transactions";
            setError(msg);
        } finally {
            setIsLoading(false);
        }
    }, [token, formatTransactions]);

    useEffect(() => {
        fetchCanceledTransactions();
    }, [fetchCanceledTransactions]);

    return { transactions, isLoading, error, refetch: fetchCanceledTransactions };
};

export default useCanceledTransactions;